var map = {
	"./": [
		7600
	],
	"./help/dollar": [
		2480,
		480
	],
	"./help/dollar.vue": [
		2480,
		480
	],
	"./help/return": [
		9765,
		765
	],
	"./help/return.vue": [
		9765,
		765
	],
	"./help/truck": [
		710,
		710
	],
	"./help/truck.vue": [
		710,
		710
	],
	"./home/about": [
		7646,
		646
	],
	"./home/about.vue": [
		7646,
		646
	],
	"./home/ads": [
		3560,
		560
	],
	"./home/ads.vue": [
		3560,
		560
	],
	"./home/map": [
		7644,
		644
	],
	"./home/map.vue": [
		7644,
		644
	],
	"./home/review": [
		1567,
		567
	],
	"./home/review.vue": [
		1567,
		567
	],
	"./index": [
		7600
	],
	"./index.vue": [
		7600
	],
	"./products/coffee": [
		119,
		119
	],
	"./products/coffee.vue": [
		119,
		119
	],
	"./products/conserve": [
		6173,
		173
	],
	"./products/conserve.vue": [
		6173,
		173
	],
	"./products/fish": [
		9517,
		517
	],
	"./products/fish.vue": [
		9517,
		517
	],
	"./products/grain": [
		9694,
		694
	],
	"./products/grain.vue": [
		9694,
		694
	],
	"./products/meat": [
		1066,
		66
	],
	"./products/meat.vue": [
		1066,
		66
	],
	"./products/product": [
		1864,
		864
	],
	"./products/product.vue": [
		1864,
		864
	],
	"./products/sugar": [
		7392,
		392
	],
	"./products/sugar.vue": [
		7392,
		392
	],
	"./products/tea": [
		6546,
		546
	],
	"./products/tea.vue": [
		6546,
		546
	],
	"./profile/active": [
		1734,
		734
	],
	"./profile/active.vue": [
		1734,
		734
	],
	"./profile/bonus": [
		9060,
		60
	],
	"./profile/bonus.vue": [
		9060,
		60
	],
	"./profile/history": [
		6662,
		662
	],
	"./profile/history.vue": [
		6662,
		662
	],
	"./profile/profile": [
		8502,
		502
	],
	"./profile/profile.vue": [
		8502,
		502
	],
	"./profile/settings": [
		6856,
		856
	],
	"./profile/settings.vue": [
		6856,
		856
	],
	"./ui/arrow": [
		1034,
		34
	],
	"./ui/arrow-enter": [
		3544,
		544
	],
	"./ui/arrow-enter.vue": [
		3544,
		544
	],
	"./ui/arrow.vue": [
		1034,
		34
	],
	"./ui/back": [
		217,
		217
	],
	"./ui/back.vue": [
		217,
		217
	],
	"./ui/cart": [
		1407,
		407
	],
	"./ui/cart.vue": [
		1407,
		407
	],
	"./ui/chevron": [
		3398,
		398
	],
	"./ui/chevron.vue": [
		3398,
		398
	],
	"./ui/edit": [
		9557,
		557
	],
	"./ui/edit.vue": [
		9557,
		557
	],
	"./ui/exit": [
		7399,
		399
	],
	"./ui/exit.vue": [
		7399,
		399
	],
	"./ui/house": [
		8236,
		236
	],
	"./ui/house.vue": [
		8236,
		236
	],
	"./ui/info": [
		8560,
		179
	],
	"./ui/info.vue": [
		8560,
		179
	],
	"./ui/mail": [
		7846,
		846
	],
	"./ui/mail.vue": [
		7846,
		846
	],
	"./ui/map": [
		2301,
		301
	],
	"./ui/map.vue": [
		2301,
		301
	],
	"./ui/minus": [
		737,
		737
	],
	"./ui/minus.vue": [
		737,
		737
	],
	"./ui/ok": [
		6362,
		362
	],
	"./ui/ok.vue": [
		6362,
		362
	],
	"./ui/phone": [
		3213,
		213
	],
	"./ui/phone.vue": [
		3213,
		213
	],
	"./ui/plus": [
		1682,
		682
	],
	"./ui/plus.vue": [
		1682,
		682
	],
	"./ui/search": [
		9993,
		993
	],
	"./ui/search.vue": [
		9993,
		993
	],
	"./ui/star": [
		4851,
		851
	],
	"./ui/star.vue": [
		4851,
		851
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2362;
module.exports = webpackAsyncContext;